import { companyURL } from 'endpoints';
import fetch from '../utils/fetch';
const CompanySdk = require( '@nackle/company-sdk' );

function CompanyService( accessToken ) {
    const fetchWithAuth = function ( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                authorization: `Bearer ${ accessToken }`,
            },
        };
        return fetch( url, options );
    };

    const sdk = new CompanySdk( companyURL, fetchWithAuth );

    const getCompanyLocales = async ( companyId ) => {
        const { locales } = await sdk.getCompany( companyId );
        return locales.sort( ( a, b ) => a.label_enUS.localeCompare( b.label_enUS ) );
    };

    return {
        getCompanyLocales
    };
}

export default CompanyService;
